module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/iron-ico-gradient-6222f1c324c4c7f315aaeb35a20b2c76.svg";